import React from "react";

const RefundPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-8">

      <h1 className="text-3xl font-bold mb-6">
        EarnProjectAcademy – Refund & Cancellation Policy
      </h1>

      <p className="mb-6">
        At EarnProjectAcademy, we aim to provide a high-quality learning
        experience through our programs and courses. Before enrolling in any
        course, please review our refund and cancellation policy carefully.
      </p>

      <h2 className="text-xl font-semibold mt-6">Important Notice</h2>

      <p className="mb-4">
        Please read this policy carefully before making any payments. All
        payments made on EarnProjectAcademy are subject to the terms mentioned
        below.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        Cancellation & Refund Policy
      </h2>

      <ul className="list-disc ml-6 mt-4 space-y-2">

        <li>
          The booking amount paid to reserve a seat in any EarnProjectAcademy
          program is strictly non-refundable.
        </li>

        <li>
          Full payments made by the student for any course or program are
          non-refundable under any circumstances.
        </li>

        <li>
          Loans or EMI payments facilitated through financial or NBFC partners,
          once issued, cannot be cancelled, paused, or refunded.
        </li>

        <li>
          In exceptional or genuine situations, students may write to our
          support team with complete details of the issue for review.
        </li>

      </ul>

      <h2 className="text-xl font-semibold mt-6">Review Process</h2>

      <p>
        Exceptional refund requests are reviewed on a case-by-case basis. The
        review process may take 7–10 business days. Approval of refunds in such
        cases is not guaranteed.
      </p>

      <h2 className="text-xl font-semibold mt-6">Additional Notes</h2>

      <ul className="list-disc ml-6 mt-4 space-y-2">

        <li>
          EarnProjectAcademy reserves the right to update or modify this policy
          at any time without prior notice.
        </li>

        <li>
          By enrolling in any EarnProjectAcademy course or program, students
          acknowledge that they have read and agreed to this refund and
          cancellation policy.
        </li>

        <li>
          All disputes related to payments or refunds will be subject to the
          jurisdiction of courts in India.
        </li>

      </ul>

      <h2 className="text-xl font-semibold mt-6">Contact Us</h2>

      <p className="mt-2">
        📧 General Inquiries: info@earnprojectacademy.com
      </p>

      <p>
        📧 Student Support: support@earnprojectacademy.com
      </p>

      <p className="mt-2">
        Response Time: 24–48 hours on business days (Monday–Saturday, 9 AM – 6 PM IST)
      </p>

    </div>
  );
};

export default RefundPolicy;